import { CatalogNode, ChangeCatalogNode } from './../../catalog.model';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { AddCatalogNode } from '../../catalog.model';

@Component({
  selector: 'change-add-catalog-node-dialog',
  templateUrl: './change-catalog-node-dialog.component.html',
  styleUrls: ['./change-catalog-node-dialog.component.scss']
})
export class ChangeCatalogNodeDialogComponent implements OnInit {

  name = new DictionaryEntry();

  catalogId: number;
  node: CatalogNode;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ChangeCatalogNodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {

    this.catalogId = data.catalogId;
    this.node = data.node;
    this.name = data.node.name;

    console.log('dialog initialized with', this.catalogId, this.node);
  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.http.postWithContext<number>(environment.erpCatalogEndpoint + '/changeCatalogNode',
      new ChangeCatalogNode({ catalogId: this.catalogId, nodeId: this.node.id, name: this.name }))
      .subscribe(response => {

        console.log('response is', response);

        this.dialogRef.close();

      }, error => {
        console.log('error is', error);
      });
  }

  confirmDisabled(): boolean {
    return this.name == null || this.name.values == null || this.name.values.length === 0 || !this.name.checkValueExistsForLanguage('de');
  }


  public onNameChanged(dictionary: DictionaryEntry) {
    this.name = new DictionaryEntry(dictionary);
  }

}
